import {
  withJsonFormsArrayControlProps,
  withJsonFormsControlProps,
} from "@jsonforms/react";
import Input from "../input";
import SelectInput from "../input/selectInput";
import MultipleSelectInput from "../input/multipleSelectInput";
import TextAreaInput from "../input/textAreaInput";
import ArrayInput from "../input/arrayInput";
import FileInput from "../input/fileInput";
import ArrayInput2 from "../input/arrayInput2";
import { MdDelete, MdAdd, MdClose, MdSearch } from "react-icons/md";
import React, { useState } from "react";

interface CustomTextInputRendererProps {
  data: any;
  uischema: any;
  handleChange(path: string, value: any): void;
  path: string;
  schema: any;
}

const CustomTextInputRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
}: CustomTextInputRendererProps) => {
  return (
    <Input
      data={data}
      onChange={(newValue) => handleChange(path, newValue)}
      label={uischema.label || "Default"}
      hasLabel={true}
      name="first_name"
      required={uischema.required}
      className="!h-14 !my-3"
    />
  );
};

const CustomNumberTextInputRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
}: CustomTextInputRendererProps) => {
  return (
    <Input
      data={data}
      onChange={(newValue) => handleChange(path, newValue)}
      label={uischema.label || "Default"}
      hasLabel={true}
      name="first_name"
      required={uischema.required}
      className="!h-14 !my-3"
      type="number"
    />
  );
};

const CustomSelectInputRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
}: CustomTextInputRendererProps) => (
  <SelectInput
    data={data}
    onChange={(newValue) => handleChange(path, newValue)}
    options={uischema.options}
    label={uischema.label}
    required={uischema.required}
    hasLabel={true}
    name="first_name"
    className="!h-14 !my-3"
  />
);

const CustomMultiSelectRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
}: CustomTextInputRendererProps) => {
  const handleSelectChange = (selectedOptions: any) => {
    let options: any[] = [];
    selectedOptions.forEach((element: { value: any }) => {
      options.push(element.value);
    });
    handleChange(path, options);
  };

  return (
    <MultipleSelectInput
      data={data}
      label={uischema.label}
      name={"producers"}
      hasLabel={true}
      options={uischema.options}
      required={uischema.required}
      onChange={handleSelectChange}
    />
  );
};

const CustomArraySelectRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
}: CustomTextInputRendererProps) => {
  const handleSelectChange = (selectedOptions: any) => {
    // let options: any[] = [];
    // selectedOptions.forEach((element: { value: any }) => {
    //   options.push(element.value);
    // });
    handleChange(path, selectedOptions);
  };

  return (
    <ArrayInput
      schema={schema}
      uischema={uischema}
      initialData={data}
      onChangeFunc={(newValue) => handleChange(path, newValue)}
    />
  );
};

const CustomArray2SelectRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
}: CustomTextInputRendererProps) => {
  const handleSelectChange = (selectedOptions: any) => {
    // let options: any[] = [];
    // selectedOptions.forEach((element: { value: any }) => {
    //   options.push(element.value);
    // });
    handleChange(path, selectedOptions);
  };
  return (
    <ArrayInput2
      schema={schema}
      uischema={uischema}
      initialData={data}
      onChangeFunc={(newValue) => handleChange(path, newValue)}
    />
  );
};

const CustomDateInputRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
}: CustomTextInputRendererProps) => (
  <Input
    data={data}
    onChange={(newValue) => handleChange(path, newValue)}
    type="date"
    label={uischema.label}
    hasLabel={true}
    name="first_name"
    required={uischema.required}
    className="!h-14 !my-3"
  />
);

const CustomTextAreaInputRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
}: CustomTextInputRendererProps) => (
  <TextAreaInput
    data={data}
    onChange={(newValue) => handleChange(path, newValue)}
    type="date"
    label={uischema.label}
    hasLabel={true}
    name="first_name"
    required={uischema.required}
    className="!h-20 !mb-12"
  />
);

const CustomFileUploadRendererControl = ({
  data,
  handleChange,
  path,
  uischema,
}: CustomTextInputRendererProps) => {
  const onFileChange = (event: any) => {
    const file = event.target.files[0];

    // if (file) {
    //   const reader = new FileReader();

    //   reader.onloadend = () => {
    //     const base64String = reader.result; // This will contain the Base64 string
    //     // Update only the 'logo' field
    //     handleChange(path, base64String);
    //   };

    //   reader.readAsDataURL(file); // This should be called before `onloadend`
    // }

    return file;
  };

  // const onFileChange = (event: any) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       const base64String = reader.result; // This will contain the Base64 string
  //       // Update only the 'logo' field
  //       handleChange(path, base64String);
  //     };

  //     reader.readAsDataURL(file); // This should be called before `onloadend`
  //   }
  // };

  return (
    <FileInput
      onChange={(newValue) => handleChange(path, newValue)}
      type="file"
      label={uischema.label}
      hasLabel={true}
      required={uischema.required}
      name="logo" // Ensure this matches the field's key in your schema
      className="!my-3"
    />
  );
};

const CustomAdventureArrayRenderer = (props: any) => {
  // ArrayControlProps provides: data, path, removeItems, addItem, moveUp, moveDown, uischema, schema, visible, enabled, errors, label, required
  const { data, path, removeItems, addItem, uischema, schema, handleChange } =
    props;

  // Use the data prop directly from withJsonFormsArrayControlProps
  const adventures = data || [];
  const availableAdventures = uischema.options?.newAdventureEnum || [];
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAdventuresForAdding, setSelectedAdventuresForAdding] =
    useState<any[]>([]);
  const [adventuresMarkedForDeletion, setAdventuresMarkedForDeletion] =
    useState<number[]>([]);
  const [adventuresToAdd, setAdventuresToAdd] = useState<number[]>([]);

  const handleMarkForDeletion = (indexToMark: number) => {
    const adventure = adventures[indexToMark];
    if (!adventure) return;

    const adventureId = adventure.value;
    setAdventuresMarkedForDeletion((prev) => {
      if (prev.includes(adventureId)) {
        // Unmark for deletion
        return prev.filter((id) => id !== adventureId);
      } else {
        // Mark for deletion
        return [...prev, adventureId];
      }
    });
  };

  // Handle selecting an adventure from the search results
  const handleSelectAdventure = (adventure: any) => {
    console.log("handleSelectAdventure called with:", adventure);
    const isAlreadySelected = selectedAdventuresForAdding.some(
      (adv: any) => adv.value?.toString() === adventure.value?.toString()
    );

    console.log("Is already selected:", isAlreadySelected);
    if (!isAlreadySelected) {
      console.log("Adding adventure to selection:", adventure);
      setSelectedAdventuresForAdding((prev) => {
        const newSelection = [...prev, adventure];
        console.log("New selectedAdventuresForAdding:", newSelection);
        return newSelection;
      });
    }
  };

  // Remove a selected adventure from the staging area
  const handleRemoveSelectedAdventure = (adventureToRemove: any) => {
    setSelectedAdventuresForAdding((prev) =>
      prev.filter(
        (adv) => adv.value?.toString() !== adventureToRemove.value?.toString()
      )
    );
  };

  // Add all selected adventures to the main list
  const handleAddSelectedAdventures = () => {
    console.log("handleAddSelectedAdventures called");
    console.log("selectedAdventuresForAdding:", selectedAdventuresForAdding);

    if (selectedAdventuresForAdding.length === 0) {
      console.log("No adventures selected, returning early");
      return;
    }

    const adventureIdsToAdd: number[] = [];

    selectedAdventuresForAdding.forEach((selectedAdventure) => {
      console.log("Processing adventure:", selectedAdventure);
      // Check if adventure is already added to main list
      const isAlreadyAdded = adventures.some(
        (adv: any) =>
          adv.value?.toString() === selectedAdventure.value?.toString()
      );

      console.log("Is already added:", isAlreadyAdded);
      if (!isAlreadyAdded) {
        console.log("Adding to main list:", selectedAdventure);
        // Use addItem function provided by ArrayControlProps
        addItem(path, {
          value: selectedAdventure.value,
          name: selectedAdventure.name,
          imageUrl: selectedAdventure.imageUrl,
        });

        // Store the ID for submission
        adventureIdsToAdd.push(selectedAdventure.value);
      }
    });

    console.log("Adventure IDs to add:", adventureIdsToAdd);
    // Update the adventuresToAdd state with the new IDs
    setAdventuresToAdd((prev) => {
      const newList = [...prev, ...adventureIdsToAdd];
      console.log("Updated adventuresToAdd:", newList);
      return newList;
    });

    // Clear the selected adventures for adding
    setSelectedAdventuresForAdding([]);
    setSearchTerm("");
    console.log("Cleared selection and search term");
  };

  // Get adventures that are not already selected
  const availableOptions = availableAdventures.filter(
    (option: any) =>
      !adventures.some(
        (adv: any) => adv.value?.toString() === option.value?.toString()
      )
  );

  // Filter available options based on search term
  const filteredOptions = availableOptions.filter((option: any) => {
    const searchLower = searchTerm.toLowerCase();
    const optionName = (option.label || option.name || "").toLowerCase();
    return optionName.includes(searchLower);
  });

  // Also exclude already selected adventures from the filtered results
  const searchResults = filteredOptions.filter(
    (option: any) =>
      !selectedAdventuresForAdding.some(
        (selected: any) =>
          selected.value?.toString() === option.value?.toString()
      )
  );

  // Store the marked for deletion list in the form data
  // This will be available in the form data when submitted
  React.useEffect(() => {
    // Access the parent form's root context to update the adventuresMarkedForDeletion field
    // We need to call the form's root handleChange to update a sibling field
    if (props.rootSchema && props.handleChange) {
      // Update the adventuresMarkedForDeletion field at the root level
      props.handleChange(
        "adventuresMarkedForDeletion",
        adventuresMarkedForDeletion
      );
    } else {
      console.log(
        "Adventures marked for deletion:",
        adventuresMarkedForDeletion
      );
    }
  }, [adventuresMarkedForDeletion, props.handleChange]);

  // Store the adventures to add list in the form data for submission
  React.useEffect(() => {
    if (props.rootSchema && props.handleChange) {
      // Update the adventuresToAdd field at the root level
      props.handleChange("adventuresToAdd", adventuresToAdd);
    } else {
      console.log("Adventures to add (IDs):", adventuresToAdd);
    }
  }, [adventuresToAdd, props.handleChange]);

  // Debug logs
  React.useEffect(() => {
    console.log("Current form data will include:", {
      adventures: adventures.map((adv: any) => ({
        id: adv.value,
        name: adv.name,
      })),
      adventuresMarkedForDeletion,
      adventuresToAdd,
    });
  }, [adventures, adventuresMarkedForDeletion, adventuresToAdd]);
  console.log("Available adventures for adding:", availableOptions);
  return (
    <div className="p-4 border border-gray-300 rounded-md my-4 bg-white shadow-sm">
      <h2 className="text-xl font-semibold mb-3">
        {schema.title || "Selected Adventures"}
      </h2>

      {/* Add New Adventure Section */}
      {availableOptions.length > 0 && (
        <div className="mb-6 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
          <h3 className="text-lg font-semibold mb-4 text-blue-900">
            Add New Adventures
          </h3>

          {/* Search Input */}
          <div className="relative mb-4">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MdSearch className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search adventures..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-500 text-sm"
            />
          </div>

          {/* Selected Adventures for Adding (Tags) */}
          {selectedAdventuresForAdding.length > 0 && (
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700 mb-2">
                Selected for adding:
              </p>
              <div className="flex flex-wrap gap-2">
                {selectedAdventuresForAdding.map((adventure, index) => (
                  <div
                    key={adventure.value}
                    className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800 border border-blue-200"
                  >
                    <span className="mr-2">
                      {adventure.label || adventure.name}
                    </span>
                    <button
                      onClick={() => handleRemoveSelectedAdventure(adventure)}
                      className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-200 hover:bg-blue-300 transition-colors"
                      aria-label={`Remove ${adventure.label || adventure.name}`}
                    >
                      <MdClose size={12} className="text-blue-600" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Search Results */}
          {searchTerm && (
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-700 mb-2">
                Search Results ({searchResults.length})
              </p>
              {searchResults.length > 0 ? (
                <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md bg-white">
                  {searchResults.map((adventure) => (
                    <div
                      key={adventure.value}
                      onClick={() => handleSelectAdventure(adventure)}
                      className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-900">
                          {adventure.label || adventure.name}
                        </span>
                        <MdAdd className="h-4 w-4 text-blue-600" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-500 italic py-2">
                  No adventures found matching "{searchTerm}"
                </p>
              )}
            </div>
          )}

          {/* Add Button */}
          {selectedAdventuresForAdding.length > 0 && (
            <button
              onClick={handleAddSelectedAdventures}
              className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 font-medium"
            >
              <MdAdd size={20} />
              Add {selectedAdventuresForAdding.length} Adventure
              {selectedAdventuresForAdding.length !== 1 ? "s" : ""}
            </button>
          )}

          {/* No search and no selections - show hint */}
          {!searchTerm && selectedAdventuresForAdding.length === 0 && (
            <div className="text-center py-8">
              <MdSearch className="mx-auto h-12 w-12 text-gray-400 mb-3" />
              <p className="text-gray-500 text-sm">
                Start typing to search for adventures to add
              </p>
            </div>
          )}
        </div>
      )}

      {/* Selected Adventures Display */}
      {adventures.length === 0 ? (
        <p className="text-gray-600 italic">
          No adventures added yet. Use the search above to find and add
          adventures.
        </p>
      ) : (
        <div>
          <h3 className="text-lg font-medium mb-3 text-gray-700">
            Selected Adventures ({adventures.length})
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {adventures.map((adventure, index) => {
              const isMarkedForDeletion = adventuresMarkedForDeletion.includes(
                adventure.value
              );
              return (
                <div
                  key={`${adventure.value}-${index}`}
                  className={`relative border rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-200 ${
                    isMarkedForDeletion
                      ? "bg-red-50 border-red-200 opacity-75"
                      : "bg-white border-gray-200"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1 pr-8">
                      <p
                        className={`font-medium text-sm leading-relaxed ${
                          isMarkedForDeletion
                            ? "text-red-600 line-through"
                            : "text-gray-800"
                        }`}
                      >
                        {adventure.name}
                        {isMarkedForDeletion && (
                          <span className="ml-2 text-xs bg-red-100 text-red-600 px-2 py-1 rounded">
                            Marked for deletion
                          </span>
                        )}
                      </p>
                    </div>
                    <button
                      onClick={() => handleMarkForDeletion(index)}
                      className={`absolute top-3 right-3 p-1.5 rounded-full transition-colors duration-200 shadow-sm ${
                        isMarkedForDeletion
                          ? "bg-gray-400 hover:bg-gray-500 text-white"
                          : "bg-red-500 hover:bg-red-600 text-white"
                      }`}
                      aria-label={`${isMarkedForDeletion ? "Unmark" : "Mark"} ${
                        adventure.name
                      } for deletion`}
                    >
                      <MdDelete size={16} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export const CustomTextInputRenderer = withJsonFormsControlProps(
  CustomTextInputRendererControl
);
export const CustomNumberTextInputRenderer = withJsonFormsControlProps(
  CustomNumberTextInputRendererControl
);
export const CustomSelectInputRenderer = withJsonFormsControlProps(
  CustomSelectInputRendererControl
);
export const CustomMultipleSelectInputRenderer = withJsonFormsControlProps(
  CustomMultiSelectRendererControl
);
export const CustomTextAreaInputRenderer = withJsonFormsControlProps(
  CustomTextAreaInputRendererControl
);
export const CustomArraySelectRenderer = withJsonFormsControlProps(
  CustomArraySelectRendererControl
);

export const CustomArray2SelectRenderer = withJsonFormsControlProps(
  CustomArray2SelectRendererControl
);

export const CustomDateInputRenderer = withJsonFormsControlProps(
  CustomDateInputRendererControl
);
export const CustomFileUploadRenderer = withJsonFormsControlProps(
  CustomFileUploadRendererControl
);

export const CustomAdventureArrayRendererControl =
  withJsonFormsArrayControlProps(CustomAdventureArrayRenderer);
